import { ApiDurationType, ApiPackageDetails } from '@ibe/api';

import React, { JSX } from 'react';
import { useMeasure } from 'react-use';

import styled from '../../../../../Styles/theme';
import useTranslation from '../../../../Hooks/useTranslation';
import { Nbsp } from '../../../../Components/UI/Nbsp';
import PackagePrice from '../PackagePrice/PackagePrice';

import fallback from '../../../../../_Translations/generated/PackageDuration.en.t.json';
import Keys from '../../../../../_Translations/generated/PackageDuration.en.t.json.keys';

// TODO rename component to PackageDetails

export interface PackageDurationProps {
  duration: ApiPackageDetails;
  onSelect: (duration: ApiPackageDetails) => void;
}

const PackageDuration = (props: PackageDurationProps): JSX.Element => {
  const { duration } = props; // TODO api design
  const packageDuration = duration.packageDurationInfo; // TODO api design
  const hotelDuration = duration.includedHotelDurationInfo; // TODO api design
  const { onSelect } = props;

  const { t } = useTranslation('PackageDuration', fallback, Keys);
  const [ref, { width }] = useMeasure<HTMLDivElement>();
  const isWide = width > 600;

  const Cont = styled.div({
    ...(isWide && {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    })
  });

  const Name = styled.div`
    font-weight: bold;
  `;

  const Left = styled.div({
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    marginTop: '1rem',
    '& > * + *': {
      marginLeft: '1rem'
    },
    ...(isWide && {
      marginTop: '0',
      alignItems: 'center'
    })
  });

  const Action = styled.button({
    whiteSpace: 'nowrap'
  });

  return (
    <div ref={ref}>
      <Cont>
        <Name>
          {packageDuration && (
            <>
              {t(packageDuration.type === ApiDurationType.NIGHT ? Keys.nights : Keys.days, {
                duration: packageDuration.duration
              })}
            </>
          )}
          <Nbsp />/<Nbsp />
          {hotelDuration && (
            <>
              {t(hotelDuration.type === ApiDurationType.NIGHT ? Keys.nights : Keys.days, {
                duration: hotelDuration.duration
              })}
            </>
          )}
        </Name>
        <Left>
          <div>
            <PackagePrice detail={duration} />
          </div>
          <Action onClick={(): void => onSelect(duration)} className="btn btn-primary">
            {t(Keys.showDetails)}
          </Action>
        </Left>
      </Cont>
    </div>
  );
};

export default PackageDuration;
